module.exports = __webpack_public_path__ + "static/media/squares.bd4d9756.svg";